import React, { useContext, createContext, useState } from 'react';
import CallAPI from '../utils/call-api';

const AuthContext = createContext();

export function useAuth() {
  return useContext(AuthContext);
}

export function AuthProvider({ children }) {
  const auth = useProvideAuth();
  return (
    <AuthContext.Provider value={auth}>
      {children}
    </AuthContext.Provider>
  );
}
  
function useProvideAuth() {
  const [user, setUser] = useState(JSON.parse(localStorage.getItem('user')));

  const signin = async (credentials) => {
    try {
      const res = await CallAPI.post('/auth/login', credentials);
      const user = res.data.user;
      setUser(user);
      localStorage.setItem('user', JSON.stringify(user));
      return user;
    } catch (err) {
      alert('กรุณาตรวจสอบเบอร์โทรหรือรหัสผ่าน');
    }
  };

  const signout = () => {
    localStorage.removeItem('user');
    setUser(null);
  };

  const refresh = async () => {
    if (!user) return;

    const res = await CallAPI.get(`/user/${user._id}`);
    setUser(prev => ({ ...res.data }));
    localStorage.setItem('user', JSON.stringify(user));
  }

  const setNumSessions = (n) => {
    setUser(prev => ({
      ...prev,
      numSessions: n,
    }));
    localStorage.setItem('user', JSON.stringify(user));
  };

  return { user, signin, signout, setNumSessions, refresh };
}
